import { IPadding } from 'src/interfaces/global';
import { addPaddingStyles, addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { IModalMobile } from './ModalMobile.type';

export const StyledModalMobile = styled.div<{ isVisible: boolean } & IPadding & Pick<IModalMobile, 'zIndex'>>`
	${(p) => css`
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: ${p.zIndex || 510};

		display: flex;
		flex-direction: column;

		background-color: #000000;

		overflow: hidden;
		text-align: center;

		${addTransition()}

		will-change: transform, opacity;

		& > span {
			position: relative;
			z-index: 201;
			text-align: left;

			height: 100%;

			overflow-y: auto;

			${addPaddingStyles(p)}

			${addTransition()}

			${p.isVisible
				? css`
						transform: scale(1);
				  `
				: css`
						transform: scale(0.95);
				  `}
		}

		${p.isVisible
			? css`
					opacity: 1;
			  `
			: css`
					opacity: 0;
			  `}

		&::before {
			content: ' ';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;

			background-color: #00000099;
		}
	`}
`;

export const StyledCrossButton = styled.button`
	position: absolute;
	top: 20px;
	right: 20px;
	z-index: 202;

	background-color: transparent;
	border: none;
	${addTransition()}
`;
